export default __webpack_public_path__ + "static/media/image_organize_schema.c5353519.svg";